import { NavigationPage } from './navigation';

export interface ContentItem {
    content: string | HTMLElement;
    type: ContentItemType;
}

export enum ContentItemType {
    CodeSnippet = 'CodeSnippet',
    Heading = 'Heading',
    Pre = 'Pre',
    RequestSnippet = 'RequestSnippet',
    Text = 'Text',
}

export interface Page extends NavigationPage {
    content: string | {[version: string]: string};
    raw_content?: string;
}

export enum PageType {
    Quip = 'quip',
    ReleaseNotes = 'contentful__release',
    ReleaseType = 'contentful__release_type',
    Versioned = 'multi-remote',
}

export interface PageUrlMap {
    [app: string]: {
        [category: string]: {
            [page: string]: string;
        };
    };
}
